<template>
  <v-container>
    <v-row class="mt-6 mb-1 hidden-md-and-down">
      <v-card elevation="5" width="100%" class="main-buttons-container mx-3 overflow-x-auto">
        <v-btn-toggle tile color="primary" shaped mandatory group v-model="selectedFilter">
          <v-btn value="0" @click="
            newCategorySelect(
              {
                articulos: totalArticulos,
                categoria: 'Todos',
                clave: null,
              },
              0
            )
            ">
            <span class="hidden-sm-and-down category-text-style">
              Todos
              <v-chip :color="selectedFilter == '0' ? 'primary' : '#BDBDBD'" class="category-chip-text-style">
                {{ totalArticulos }}
              </v-chip>
            </span>
          </v-btn>

          <v-btn v-for="(item, index) in categoryItems" :key="index" :value="item.clave"
            @click="newCategorySelect(item, index)">
            <span class="category-text-style">
              {{ item.categoria }}
              <v-chip :color="selectedFilter == item.clave ? 'primary' : '#BDBDBD'" class="category-chip-text-style">
                {{ item.articulos }}
              </v-chip>
            </span>
          </v-btn>

          <v-btn value="NoView" id="Ocultar" active-class="aa" :exact="true" style="display: none">
          </v-btn>
        </v-btn-toggle>
      </v-card>
    </v-row>
    <div class="reporte-menu mt-4 hidden-lg-and-up">
      <v-expansion-panels v-model="panel">
        <v-expansion-panel>
          <v-expansion-panel-header class="text-center">
            <template v-slot:default>
              <p class="card-title-text">{{ mobileMenuShowedName }}</p>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" v-for="(item, index) in categoryItems" :key="index">
                <v-btn block text :value="item.clave" @click="newCategorySelect(item, index)">
                  {{ item.categoria }}
                </v-btn>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div style="height: 15px"></div>
    <div width="82.5vw" v-if="items.length > 0">
      <masonry-infinite-grid class="container" v-bind:gap="15" v-on:request-append="onRequestAppend">
        <v-card elevation="10" class="item-style" v-for="(item, index) in items" :key="index"
          :data-grid-groupkey="item.groupKey">
          <div style="width: 100%">
            <div style="display: flex; flex-direction: row">
              <img class="blog-autor-container-style" v-bind:src="'https://www.ausa.com.mx/img/ausa_logo_vector_v3.png'"
                alt="logo_ausa" />

              <div class="blog-title-container">
                <p class="autor-text-style">{{ item.uslogin }}</p>
                <p class="title-text-style">
                  <a @click="showBlogPost(item)">
                    {{ item.batitulo }}
                  </a>
                </p>
                <p class="fecha-text-style">
                  {{ formatoFecha(item.bafhpublicacion) }}
                </p>
              </div>
            </div>
          </div>
          <div>
            <p class="desc-text-style">
              {{ item.badesc }}
            </p>
          </div>
          <div class="thumbnail">
            <div v-if="item.baEnAmazonS3 == 1">
              <img v-bind:src="item.baimagen" :alt="item.badesc" class="image-rounded-style"
                @click="showBlogPost(item)" />
            </div>
            <div v-else>
              <img v-bind:src="dynamicRoute + item.baimagen" :alt="item.badesc" class="image-rounded-style"
                @click="showBlogPost(item)" />
            </div>
          </div>
          <div style="width: 100%" class="mt-3">
            <div style="display: flex" v-if="item.EntradaPorUsuario == 0">
              <v-btn text style="margin-left: auto" @click="clickOnLike(item, index)">
                <v-icon size="16" style="margin-right: 5px">mdi-thumb-up</v-icon>
                Me Gusta
              </v-btn>
              <div style="float: right">
                <v-avatar color="primary" size="35" tile>
                  <span style="color: #ffffff">{{ item.CantidadLike }}</span>
                </v-avatar>
              </div>
            </div>

            <div style="display: flex" v-if="item.EntradaPorUsuario == 1">
              <v-btn text style="margin-left: auto" color="primary" @click="clickOnDislike(item, index)">
                <v-icon size="16" style="margin-right: 5px">mdi-thumb-up</v-icon>
                Me Gusta
              </v-btn>
              <div style="float: right">
                <v-avatar color="primary" size="35" tile>
                  <span style="color: #ffffff">{{ item.CantidadLike }}</span>
                </v-avatar>
              </div>
            </div>
          </div>
        </v-card>
      </masonry-infinite-grid>
      <div v-if="loadingNewPost" width="82.5vw" class="py-5 loader-container">
        <div class="auto-margin">
          <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
        </div>
      </div>
    </div>
    <div v-else width="82.5vw" class="py-5 loader-container">
      <div class="auto-margin">
        <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import BlogService from "@/services/Blogs/Blogs.service.js";
import { MasonryInfiniteGrid } from "@egjs/vue-infinitegrid";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";

export default {
  title() {
    return this.$route.meta.title
  },
  components: {
    MasonryInfiniteGrid,
  },
  props: ['canOnlySee'],
  data() {
    return {
      items: [],
      categoryItems: [],
      totalArticulos: 0,
      currentMaxBlogsOnScreen: 0,
      mobileMenuShowedName: "Todos",
      selectedMenu: "",
      selectedFilter: "",
      currentFilter: null,

      panel: null,

      postItemPerPage: 10,
      loadingNewPost: false,
      dynamicRoute: "https://www.ausa.com.mx/"
    };
  },
  computed: {
    ...mapState([
      "domain",
      "informationPage",
    ])

  },
  async mounted() {
    this.dynamicRoute = this.domain.domainNameDev;
    this.obtenerTotalArticulos();
    this.obtenerCategorias();
    this.getInitialItems(1, 10, null);
  },
  methods: {
    async AWSImageRetrive(route, index) {
      const response = await BlogService.ObtenerImagenBlogSingle(route);
      let data = await JSON.parse(response);
      let url = await data.watch.toString()
      this.items[index].awsImg = url;
      return url;
    },

    async showBlogPost(item) {
      let token = await MetodosGenerales.generateJsonToken(item);
      this.$emit('toggle-detail', token);
    },
    formatoFecha(date) {
      var fecha = moment(date).format("DD/MM/YYYY HH:mm");
      return fecha;
    },
    async newCategorySelect(item, index) {
      //TODO: IDK
      this.selectedFilter = item.clave;
      this.currentFilter = item.clave;
      this.mobileMenuShowedName = item.categoria;
      this.currentMaxBlogsOnScreen = item.articulos;
      if (this.currentMaxBlogsOnScreen < 10) {
        this.postItemPerPage = item.articulos;
      } else {
        this.postItemPerPage = 10;
      }

      this.panel = null;

      this.getInitialItems(1, this.postItemPerPage, item.clave);
    },

    async getInitialItems(nextGroupKey, count, filter) {
      this.items = [];
      this.items = await this.getItems(nextGroupKey, count, filter);
    },

    async getItems(nextGroupKey, count, filter) {
      this.loadingNewPost = true;
      let nextItems = [];

      let response = await BlogService.ObtenerPostPrincipal(
        nextGroupKey,
        count,
        filter
      );
      let cont = 0;
      await response.forEach((element) => {
        element.awsImg = "";
        const nextKey = nextGroupKey * count + cont;
        nextItems.push({ ...element, groupKey: nextGroupKey, key: nextKey });
        cont = cont + 1;
      });
      this.loadingNewPost = false;
      return nextItems;
    },

    async onRequestAppend(e) {
      if (this.items.length < this.currentMaxBlogsOnScreen - 1) {
        e.wait();
        const actualGroup = e.groupKey != null ? e.groupKey : 1;
        const nextGroupKey = actualGroup + 1;

        const resultNewItems = await this.getItems(
          nextGroupKey,
          this.postItemPerPage,
          this.currentFilter
        );
        const result = this.items.concat(resultNewItems);
        e.ready();
        this.items = result;
      }
    },

    async obtenerCategorias() {
      let response = await BlogService.ObtenerCategorias();
      this.categoryItems = response;
    },

    async obtenerTotalArticulos() {
      let response = await BlogService.ObtenerTotalArticulos();
      this.totalArticulos = response;
      this.currentMaxBlogsOnScreen = response;
    },

    async clickOnLike(item, index) {
      this.items[index].EntradaPorUsuario = 1;
      this.items[index].CantidadLike = this.items[index].CantidadLike + 1;
      let response = await BlogService.LikeBlogPost(item.baclave);
    },

    async clickOnDislike(item, index) {
      this.items[index].EntradaPorUsuario = 0;
      this.items[index].CantidadLike = this.items[index].CantidadLike - 1;
      let response = await BlogService.LikeBlogPost(item.baclave);
    },
  },
};
</script>

<style>
.main-buttons-container::-webkit-scrollbar {
  height: 0.4em;
  border-radius: 50%;
}

.main-buttons-container::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(165, 165, 165, 0.3);
}

.main-buttons-container::-webkit-scrollbar-thumb {
  background-color: rgb(155, 155, 155);
  outline: 1px solid rgb(177, 177, 177);
}

.image-rounded-style {
  border-radius: 14px;
}
</style>

<style scoped>
.auto-margin {
  margin: auto;
  width: min-content;
}

.loader-container {
  height: 150px;
}

.card-title-text {
  font-size: 1.3rem !important;
  font-weight: 500 !important;
  text-align: center !important;
  margin-top: 2px !important;
  margin-bottom: 2px !important;
}

.blog-title-container {
  width: 90%;
  padding: 2px 2px 2px 10px;
}

.blog-autor-container-style {
  width: 65px;
  height: 65px;
  border-radius: 50%;
}

.autor-text-style {
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 0px;
}

.fecha-text-style {
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  font-weight: 200;
  color: grey;
  margin-bottom: 0px;
}

.desc-text-style {
  font-family: "Poppins", sans-serif;
  font-size: 15px;
  font-weight: 400;
  color: grey;
  margin-bottom: 5px;
}

.title-text-style {
  font-family: "Poppins", sans-serif;
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 0px;
}

.likes-container-style {
  min-width: 30px;
  background-color: cornflowerblue;
  padding: 2px 12px 2px 12px;
  color: #ffffff;
}

.category-text-style {
  font-family: "Poppins", sans-serif;
  font-size: 12px !important;
  font-weight: 600;
}

.category-chip-text-style {
  font-family: "Poppins", sans-serif;
  font-size: 11px !important;
  font-weight: 500;
}

/* TODO: THIS SHOULD BE RESPONSIVE */
.item-style {
  min-width: 100%;
  width: 32.5%;
  max-width: 100%;
  padding: 10px 10px 10px 10px;
}

@media screen and (min-width: 900px) {
  .item-style {
    min-width: 49%;
    width: 32.5%;
    max-width: 100%;
    padding: 10px 10px 10px 10px;
  }
}

@media screen and (min-width: 1530px) {
  .item-style {
    min-width: 32.5%;
    width: 32.5%;
    max-width: 100%;
    padding: 10px 10px 10px 10px;
  }
}
</style>
